function deepFreeze(obj: {}) {
    // Retrieve the names of all properties in the object
    let propNames = Object.getOwnPropertyNames(obj);

    // Freeze each property before freezing the object itself
    propNames.forEach(function (name) {
        let prop = obj[name];

        // Recursively freeze nested objects
        if (typeof prop === 'object' && prop !== null) {
            deepFreeze(prop);
        }
    });

    // Freeze the object itself
    return Object.freeze(obj);
}

const freeze = (obj: {}) => {
    return deepFreeze(obj);
};

export default freeze;
